export default __webpack_public_path__ + "static/media/speech.a438ddce.svg";